<template>
  <el-table :data="data" style="width: 100%" :empty-text="$t('common.no_values')" @select-all="handleSelectAll" @select="handleSelectRow">
    <user-info-table-column :label="$t('common.name')" sortable prop="composed" :is-show-email="false" screen="teacher" />

    <el-table-column :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'teachers_page.table.number_of_classes'))" sortable prop="groups_count" align="center" />

    <el-table-column :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'teachers_page.table.number_of_students'))" sortable prop="users_groups_count" align="center" />

    <el-table-column>
      <template slot-scope="scope">
        <div class="flex">
          <span class="edit-teacher" @click="edit(scope.row)" :title="$t($i18nLabelsHelper(currentOrganizationType, 'update_teacher_from_organization'))">
            <i class="elsa-icon-edit" />
          </span>
          <span class="remove-learner" @click="remove(scope.row.id)" :title="$t($i18nLabelsHelper(currentOrganizationType, 'remove_teacher_from_organization'))">
            <i class="elsa-icon-grey-delete" />
          </span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import UserInfoTableColumn from '@/components/classes/UserInfoTableColumn'
import { mapGetters } from 'vuex'
import { always, identity, propOr } from 'ramda'

export default {
  props: {
    data: {
      type: Array,
      default: always([])
    },
    handleSelectAll: {
      type: Function,
      default: identity
    },
    handleSelectRow: {
      type: Function,
      default: identity
    },
    handleRemove: {
      type: Function,
      default: identity
    },
    handleUpdate: {
      type: Function,
      default: identity
    }
  },
  components: {
    UserInfoTableColumn
  },
  computed: {
    getOrganizationGroups: propOr([], 'getClassList'),
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  methods: {
    remove(id) {
      this.handleRemove(id)
    },
    edit(teacher) {
      this.handleUpdate(teacher)
    }
  }
}
</script>

<style lang="scss" scoped></style>
